// @flow

import {
  RECEIVE_PDB_IDS, SET_PDB_ID, UNSET_PDB_ID, UNSET_ALL_PDB_IDS,
} from './constants';
import type { Actions as PdbComparisonActions } from './actions';
import type { State } from './types';

const initialState: State = [];

export default (state: State = initialState, action: PdbComparisonActions): State => {
  switch (action.type) {
    case SET_PDB_ID: {
      const items = new Set(state);
      items.add(action.pdbId);
      return Array.from(items);
    }
    case RECEIVE_PDB_IDS:
      return action.payload;
    case UNSET_PDB_ID: {
      const items = new Set(state);
      items.delete(action.pdbId);
      return Array.from(items);
    }
    case UNSET_ALL_PDB_IDS:
      return [];
    default:
      return state;
  }
};
